export interface TooltipProps {
  top: string;
  left: string;
  xValue: string;
  yValue: number;
  visible: boolean;
  unit: string;
  xAxisType?: 'date' | 'string';
}

export const EMPTY_TOOLTIP: TooltipProps = {
  top: '0',
  left: '0',
  xValue: '',
  yValue: 0,
  visible: false,
  unit: '€',
  xAxisType: 'string',
};
